<div class="customer-history-details-container">
    <h1 class="dialog-title">Change Details</h1>
    <div class="dialog-content">
        <div *ngIf="data && (data.newCustomerInfoByGroup != null || data.oldCustomerInfoByGroup != null)">
            <app-customer-info-by-group-history
            [newCustomerInfoByGroup]="newCustomerInfoByGroup"
            [oldCustomerInfoByGroup]="oldCustomerInfoByGroup"
            ></app-customer-info-by-group-history>
        </div>

        <div *ngIf="data && (data.newContact != null || data.oldContact != null)">
            <app-customer-contact-history
              [oldContact]="oldContact"
              [newContact]="newContact"
            >
            </app-customer-contact-history>
        </div>

        <div *ngIf="data && (data.oldCustomerAircrafts != null || data.newCustomerAircrafts != null)">
            <app-customer-aircraft-history
            [newCustomerAircrafts]="newCustomerAircrafts"
            [oldCustomerAircrafts]="oldCustomerAircrafts"
            [newAircraft]="newAircraft"
            [oldAircraft]="oldAircraft"
            >
            </app-customer-aircraft-history>
        </div>

        <div *ngIf="data && data.oldPricingTemplate != null && data.newPricingTemplate != null">
           <app-cutomer-itp-mragin-history
              [newPricingTemplate]="newPricingTemplate"
              [oldPricingTemplate]="oldPricingTemplate"
           ></app-cutomer-itp-mragin-history>
        </div>
    </div>
    <div class="dialog-actions">
        <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>Ok</button>
    </div>
</div>
